export const categories = {
  O: "Автономна Республіка Крим, області",
  K: "міста, що мають спеціальний статус",
  P: "райони в областях та Автономній Республіці Крим",
  H: "території територіальних громад (назви територіальних громад) в областях, територіальні громади Автономної Республіки Крим",
  M: "міста",
  T: "селища міського типу",
  C: "села",
  X: "селища",
  B: "райони в містах",
} as const;

export type Category = keyof typeof categories;

export type Item = {
  level1: string;
  level2: string | null;
  level3: string | null;
  level4: string | null;
  level5: string | null;
  category: Category;
  name: string;
};

type KATOTTG = {
  orderDate: string;
  categories: typeof categories;
  items: Item[];
};

export async function setupCities() {
  const regionSelect = document.getElementById("region") as HTMLSelectElement;
  if (!regionSelect) {
    return;
  }

  const baseUrl = import.meta.url;
  const katottgUrl = import.meta.env.PROD
    ? new URL("katottg.min.json", baseUrl).href
    : "/katottg.min.json";
  const response = await fetch(katottgUrl);
  const { items } = (await response.json()) as KATOTTG;
  const sort = ({ name: name1 }: Item, { name: name2 }: Item): number => {
    return name1.localeCompare(name2);
  };
  const regions = items
    .filter(({ category }) => category === "O" || category === "K")
    .toSorted(sort);

  const citySelect = document.getElementById("city") as HTMLSelectElement;

  regions.forEach(({ level1, name }) => {
    const option = document.createElement("option");
    option.value = name;
    option.dataset.code = level1;
    option.textContent = name;
    regionSelect.appendChild(option);
  });

  regionSelect.addEventListener("change", (ev) => {
    const currentRegion = regionSelect.selectedOptions[0].dataset.code;
    citySelect.length = 0;
    const cities = items
      .filter(
        ({ level1, category }) =>
          level1 === currentRegion &&
          (category === "K" ||
            category === "M" ||
            category === "T" ||
            category === "C" ||
            category === "X"),
      )
      .toSorted(sort);

    const option = document.createElement("option");
    option.textContent = "—Виберіть варіант—";
    citySelect.appendChild(option);

    cities.forEach(({ name }) => {
      const option = document.createElement("option");
      option.value = name;
      option.textContent = name;
      citySelect.appendChild(option);
    });
  });
}
